<template>
  <div>
    <div class="w-full xl:w-12/12 mb-12 xl:mb-0 ">
      <div class="relative flex flex-col min-w-0 break-words w-full mb-4 p-4 shadow-lg rounded-lg bg-white">
        <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div class="flex flex-wrap items-center">
            <div class="relative w-full max-w-full flex-grow flex-1">
              <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
                DETAILS OF USING THE SYSTEM
              </h6>
              <h2 class="text-blueGray text-xl font-semibold">
                Overview of Dahla SmartGrade
              </h2>
            </div>
          </div>
        </div>

        <div class="flex-auto w-full px-4">
          <select ref="course_id" v-model="selectedCourse" @change="smartgrade_grade"
            class="block w-full mt-3 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed">
            <option value="26">Doctor of Medicine Program</option>
            <option value="28">Radiological Technology</option>
            <option value="29">Physical Therapy</option>
            <option value="30">Emergency Medical Operation</option>
          </select>
          <select ref="class_id" v-model="selectedClass" @change="smartgrade_grade"
            class="block w-full mt-3 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed">
            <option value="0">All</option>
            <option value="1">Year 1</option>
            <option value="2">Year 2</option>
            <option value="3">Year 3</option>
            <option value="4">Year 4</option>
            <option value="5">Year 5</option>
            <option value="6">Year 6</option>
          </select>
        </div>

        <div class="flex-auto w-full px-4">
          <div class="pt-6  flex-auto">
            <div class="flex flex-wrap">
              <div
                class="w-full lg:w-5/12 mr-auto px-4 pt-6 pb-4 h-full mb-2 shadow rounded-lg border-0 bg-emerald-200">
                <div
                  class="text-white p-3 text-center mr-2 mb-4 inline-flex items-center justify-center w-5 h-5 shadow-lg rounded-md bg-emerald-500">
                  <i class="fas fa-arrow-up"></i>
                </div>
                <span class="text-blueGray text-lg font-semibold text-blueGray">
                  Top 5 Most Grade Rankings
                </span>
                <div class="block w-full overflow-x-auto">
                  <table class="items-center w-full pt-2 rounded-lg bg-white text-sm">
                    <tbody>
                      <tr v-if="grade_most_arr.length === 0">
                        <td colspan="2" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                      </tr>
                      <tr v-for="(grade_most, index) in grade_most_arr" :key="index">
                        <td
                          class="w-full lg:w-8/12 border-t-0 px-6 p-1 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                          {{ grade_most.student_id }}
                        </td>
                        <td
                          class="w-full lg:w-4/12 border-t-0 px-6 p-1 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                          {{ grade_most.GPA }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="w-full lg:w-5/12 px-4 pt-6 pb-4 h-full mb-2 shadow rounded-lg border-0 bg-red-200">
                <div
                  class="text-white p-3 text-center mr-2 mb-4 inline-flex items-center justify-center w-5 h-5 shadow-lg rounded-md bg-red-500">
                  <i class="fas fa-arrow-down"></i>
                </div>
                <span class="text-blueGray text-lg font-semibold text-blueGray">
                  Top 5 Least Grade Rankings
                </span>
                <div class="block w-full overflow-x-auto ">
                  <table class="items-center w-full pt-2 rounded-lg bg-white text-sm">
                    <tbody>
                      <tr v-if="grade_least_arr.length === 0">
                        <td colspan="2" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                      </tr>
                      <tr v-for="(grade_least, index) in grade_least_arr" :key="index">
                        <td
                          class="w-full lg:w-8/12 border-t-0 px-6 p-1 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                          {{ grade_least.student_id }}
                        </td>
                        <td
                          class="w-full lg:w-4/12 border-t-0 px-6 p-1 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                          {{ grade_least.GPA }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap mt-4">
      <div class="w-full xl:w-6/12 pr-4">
        <div class="relative flex flex-col min-w-0 break-words w-full mb-4 p-4 shadow-lg rounded-lg bg-white">
          <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
            <div class="flex flex-wrap items-center">
              <div class="relative w-full max-w-full flex-grow flex-1">
                <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
                  TOTAL NUMBER OF SUBJECTS
                </h6>
                <h2 class="text-blueGray text-xl font-semibold">
                  Overview of Model
                </h2>
              </div>
            </div>
          </div>

          <div class="relative flex flex-col min-w-1 break-words bg-white w-full rounded-lg mt-2">
            <div class="px-4 py-5 flex-auto ">
              <div class="tab-content tab-space ">
                <div class="relative">
                  <canvas ref="chartCanvasModel" class="disable-mouse"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full xl:w-6/12 ">
        <div class="relative flex flex-col min-w-0 break-words w-full mb-4 p-4 shadow-lg rounded-lg bg-white">
          <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
            <div class="flex flex-wrap items-center">
              <div class="relative w-full max-w-full flex-grow flex-1">
                <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
                  TOTAL NUMBER OF GRADE RESULT
                </h6>
                <h2 class="text-blueGray text-xl font-semibold">
                  Overview of Grade (GPA)
                </h2>
              </div>
            </div>
          </div>

          <div class="flex-auto w-full">
            <div class="relative flex flex-col min-w-1 break-words bg-white w-full ">
              <div class="px-4 py-5 flex-auto ">
                <div class="tab-content tab-space ">
                  <div class="relative">
                    <canvas ref="chartCanvas" class="disable-mouse"></canvas>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




</template>
<script>
import api from './../../services/student_services';
import { Bar } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  name: 'App',
  data() {
    return {
      selectedClass: "0", // ค่าเริ่มต้นที่ถูกเลือก
      selectedCourse: "26", // ค่าเริ่มต้นที่ถูกเลือก
      grade_most_arr: [],
      grade_least_arr: [],
      model_arr: [],
      data_id: {
        "course_id": '',
        "class_year": ''
      },
    };
  },
  methods: {
    async smartgrade_grade() {
      this.data_id = {
        "class_year": this.selectedClass,
        "course_id": this.selectedCourse
      }

      api.smartgrade_grade_most(this.data_id).then(async (result) => {
        this.grade_most_arr = result.data;

      });
      api.smartgrade_grade_least(this.data_id).then(async (result) => {
        this.grade_least_arr = result.data;
      });

      api.smartgrade_grade(this.data_id).then(async (result) => {
        this.student_med_arr = result.data;

        this.$nextTick(function () {
          const ctx = this.$refs.chartCanvas.getContext('2d');

          const data_sum_normal_M = [];
          const data_sum_normal_F = [];
          const data_sum_delay_M = [];
          const data_sum_delay_F = [];

          this.student_med_arr.forEach((student_list) => {
            data_sum_normal_M.push(student_list.sum_normal_M);
            data_sum_normal_F.push(student_list.sum_normal_F);
            data_sum_delay_M.push(student_list.sum_delay_M);
            data_sum_delay_F.push(student_list.sum_delay_F);
          });

          new Bar(ctx, {
            data: {
              labels: [
                'GPA < 1.50',
                'GPA 1.50 - 1.99',
                'GPA 2.00 - 2.49',
                'GPA 2.50 - 2.99',
                'GPA 3.00 - 3.49',
                'GPA 3.50 - 4.00',
              ],
              datasets: [
                {
                  label: 'Male (Regular)',
                  data: data_sum_normal_M,
                  backgroundColor: "#007869",
                  stack: 'Stack 0',
                },
                {
                  label: 'Male (Delay)',
                  data: data_sum_delay_M,
                  backgroundColor: "#EF4444",
                  stack: 'Stack 0',
                },
                {
                  label: 'Female (Regular)',
                  data: data_sum_normal_F,
                  backgroundColor: "#00A65A",
                  stack: 'Stack 1',
                },
                {
                  label: 'Female (Delay)',
                  data: data_sum_delay_F,
                  backgroundColor: "#EF4444",
                  stack: 'Stack 1',
                },
              ],
            },
            options: {
              responsive: true,
              interaction: {
                intersect: false,
              },
              scales: {
                x: {
                  stacked: false
                },
                y: {
                  stacked: true,
                  beginAtZero: true
                }
              },
              plugins: {
                datalabels: {
                  color: '#FFFFFF',
                  formatter: (data) => {
                    return data != 0 ? data : '';
                  }
                }
              }
            },
            plugins: [ChartDataLabels],
          });
        });
      });

      api.smartgrade_model(this.data_id).then(async (result) => {
        this.model_arr = result.data;
        
        this.$nextTick(function () {

          const ctx = this.$refs.chartCanvasModel.getContext('2d');
          new Bar(ctx, {
            data: {
              labels: ['A:Copy Grade Only', 'B:Upload All', 'C:Calculation', 'C:Calculation (Upload)', 'D:Extern', 'E:Good/Pass/Fail', 'COMPRE'],
              datasets: [
                {
                  // label: 'Number of Subjects',
                  data: [this.model_arr.count_a, this.model_arr.count_b, this.model_arr.count_c, this.model_arr.count_c_upload, this.model_arr.count_d, this.model_arr.count_e, this.model_arr.count_compre],
                  backgroundColor: ["#2E476B", "#6187B8", "#fd6f2f", "#fb9b50", "#C7B08D", "#E08992", "#AF666A"],
                },
              ],
            },
            options: {
              legend: {
                display: false
              },
              responsive: true,
              interaction: {
                intersect: false,
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              },
              plugins: {
                datalabels: {
                  // align: 'end',
                  // anchor: 'end',
                  color: '#FFFFFF',
                  formatter: (data) => {
                    return data != 0 ? data : '';
                  },
                  // color: function (context) {
                  //   return context.dataset.backgroundColor;
                  // },
                  font: function (context) {
                    var w = context.chart.width;
                    return {
                      size: w < 512 ? 12 : 14,
                      weight: 'bold',
                    };
                  },
                  // formatter: function (value, context) {
                  //   return context.chart.data[context.dataIndex];
                  // }
                }
              }
            },
            plugins: [ChartDataLabels],
          });
        });
      });
    },
  }, created: async function () {
    await this.smartgrade_grade()
  },
};
</script>

<style scoped>
.disable-mouse {
  pointer-events: none;
}
</style>